// extracted by mini-css-extract-plugin
export default {"sliderControlInner":"slider-control__sliderControlInner___2lee0"};